console.log("custom.js loaded!");

(function(){
  const couponCodeButton = document.querySelector('.coupon_apply_code_container');
  if(couponCodeButton){
    const apply_btn = couponCodeButton?.querySelector('button');
    if(apply_btn){
      apply_btn.addEventListener('click', checkDiscountCode.bind(this))
    }
  }
  async function getCartJson() {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`);
    const responseData = await response.json();
    return responseData;
  }
  async function checkDiscountCode(event){
    const _this = event.target;
    const closestMainContainer = _this?.closest('.coupon_code_main_container')
    const closestInput = _this?.closest('.coupon_apply_code_container')?.querySelector('[name="coupon_code_cart"]');
    var has_product = false;
    if(!closestInput.value == ''){
      const inputValue = closestInput?.value;
      const cartJson = await getCartJson();
      Array.from(cartJson.items).forEach(item=>{
        if(item.id === 49999932686623){
          has_product = true;
        }
      });
    }
    if(has_product === true){
      const error_message = closestMainContainer?.querySelector('.error_message');
      if(error_message && error_message.hasAttribute('hidden')){
        error_message.removeAttribute('hidden');
      }
    }
  }
})()

//Cart Drawer And Cart Page Checkbox Validation Check
const CheckoutButton = document.querySelector('#CheckOut');
const CheckoutCheckbox = document.querySelector('#CartAgree');

// const CheckoutButton = document.getElementById('CheckOut');
// const CheckoutCheckbox = document.getElementById('CartAgree');

if(CheckoutButton || CheckoutCheckbox){
  if(CheckoutButton.classList.contains('show_cart_message')){    
    CheckoutButton.addEventListener('click', function (event) {
      event.preventDefault();
      console.log("clicked");
      if (CheckoutCheckbox.checked){
        CheckoutCheckbox.classList.remove("checkbox-error");
        document.location.href = '/cart/checkout';
      }else{
        CheckoutCheckbox.classList.add("checkbox-error");
        return false;
      }  
    });
  }
}

